import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import { GlowOrb } from '@/components/effects/glow-orb';

export function RegistrationClosedScreen(): ReactNode {
  const nav = useNavigate();
  return (
    <div className="relative flex min-h-dvh items-center justify-center bg-void px-md">
      <GlowOrb />
      <div className="relative z-10 flex max-w-[420px] flex-col items-center gap-md text-center">
        <h1 className="font-display text-lg font-bold text-text-primary sm:text-xl">
          Las inscripciones est&aacute;n cerradas
        </h1>
        <p className="text-sm text-text-secondary">
          Vuelve m&aacute;s adelante, reabriremos pronto.
        </p>
        <Button
          size="lg"
          className="mt-sm w-full"
          onClick={() => nav('/', { replace: true })}
        >
          Volver al inicio
        </Button>
      </div>
    </div>
  );
}
